export default class LogoAnimation {
  constructor() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const svg = document.querySelector(".c-masthead__logo-svg");
    if (!svg) return;

    const dots = Array.from(svg.querySelectorAll("circle, path"));

    // Fisher-Yates shuffle
    for (let i = dots.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [dots[i], dots[j]] = [dots[j], dots[i]];
    }

    const steps = 60;   // number of distinct delay groups
    const total = 600; // total spread in ms

    dots.forEach((dot, i) => {
      const t = Math.pow(i / (dots.length - 1), 2); // decelerate
      const quantized = Math.round(t * steps) / steps;
      dot.style.animationDelay = `${quantized * total}ms`;
    });

    requestAnimationFrame(() => {
      svg.classList.add("is-animating");
    });
  }
}
